module.exports = __webpack_public_path__ + "static/images/hb6.7706339.jpg";